// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__uT2S0 {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--text-color0);
  margin-bottom: 1rem;
  word-spacing: 0.1em;
}

.styles_title__uT2S0 span {
  color: #EEB547;
}

.styles_subtitle__bRkeS {
  font-size: 1.1rem;
  color: var(--text-color1);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .styles_title__uT2S0 {
    font-size: 1.8rem;
  }

  .styles_subtitle__bRkeS {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .styles_title__uT2S0 {
    font-size: 1.5rem;
  }

  .styles_subtitle__bRkeS {
    font-size: 0.95rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/public/Home/Download/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n  word-spacing: 0.1em;\n}\n\n.title span {\n  color: #EEB547;\n}\n\n.subtitle {\n  font-size: 1.1rem;\n  color: var(--text-color1);\n  line-height: 1.6;\n}\n\n@media (max-width: 768px) {\n  .title {\n    font-size: 1.8rem;\n  }\n\n  .subtitle {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .subtitle {\n    font-size: 0.95rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__uT2S0`,
	"subtitle": `styles_subtitle__bRkeS`
};
export default ___CSS_LOADER_EXPORT___;
